import React from "react";
import "./App.css";
import { Embed } from "the-immersion-quest-audio/dist";

function App() {
  return (
    <div className="App">
 
      <div className="home-centered centered absolute">
        <div
          className="content"
          style={{
            border: "1px solid black",
            borderRadius: "6px",
            overflow: "hidden",
            boxShadow: "0 0 10px black",
            maxWidth: "80vw"
          }}
        >
          <Embed
            wsEndpoint="wss://api.immersion.quest"
            httpEndpoint="https://api.immersion.quest"
            prompt={"Dans la forêt de majencourage, les animaux cherchent desespèrement une échappatoire"}
          ></Embed>
        </div>
      </div>
    </div>
  );
}

export default App;
